import { render, staticRenderFns } from "./image-upload-icon.vue?vue&type=template&id=45048b3c&"
import script from "./image-upload-icon.vue?vue&type=script&lang=js&"
export * from "./image-upload-icon.vue?vue&type=script&lang=js&"
import style0 from "./image-upload-icon.vue?vue&type=style&index=0&id=45048b3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports